module.exports = __webpack_public_path__ + "static/media/image (27).0094cfc6.jpg";